import React from 'react';
import { Grid } from '@material-ui/core';

import yup from '../../utility/yup';
import {
  FormSwitch,
  Permission,
  FormInput,
  SectionTitle,
} from '../../components';
import { is, roles } from '../../utility/guard';

export const optionsSchema = {
  'options.auto_center_vertical_offset': yup.string(),
};

const TabOptions = () => (
  <Grid container spacing={4}>
    <Grid item xs={12}>
      <SectionTitle>Visual</SectionTitle>
    </Grid>
    <Grid container item spacing={1}>
      <Grid item xs={12}>
        <FormSwitch
          label="Shadow"
          name="options.shadow"
        />
      </Grid>
      <Grid item xs={12}>
        <FormSwitch
          label="Checkbox"
          name="options.autoplay"
        />
      </Grid>
      <Grid item xs={12}>
        <FormSwitch
          label="Show watch progress"
          name="options.show_watched_progress"
        />
      </Grid>
      <Grid item xs={12}>
        <FormSwitch
          label="Hide menu title"
          name="options.hide_menu_text"
        />
      </Grid>
      <Grid item xs={12}>
        <FormSwitch
          label="Show menu on right"
          name="options.show_menu_on_right"
        />
      </Grid>
      <Grid item xs={12}>
        <FormSwitch
          label='Show "Powered By PitchHub" on menu'
          name="options.show_powered_by_on_menu"
        />
      </Grid>
      <Grid item xs={12}>
        <FormSwitch
          label='Show "Powered By PitchHub" on video'
          name="options.show_powered_by_on_video"
        />
      </Grid>
      <Grid item xs={12}>
        <FormSwitch
          label="Auto center"
          name="options.auto_center"
        />
      </Grid>
    </Grid>
    <Grid item sm={4} xs={6}>
      <FormInput
        label="Auto center offset"
        name="options.auto_center_vertical_offset"
        spellCheck
      />
    </Grid>
    <Grid item xs={12}>
      <SectionTitle>Contact</SectionTitle>
    </Grid>
    <Grid container item spacing={1}>
      <Grid item xs={12}>
        <FormSwitch
          label="Collect customer last name"
          name="options.collect_last_name"
        />
      </Grid>
      <Grid item xs={12}>
        <FormSwitch
          label="Include customer info in notification email"
          name="options.customer_include_all_in_email"
        />
      </Grid>
    </Grid>
    <Permission guard={is(roles.superAdmin)}>
      <Grid item xs={12}>
        <SectionTitle>Admin</SectionTitle>
      </Grid>
      <Grid container item spacing={1}>
        <Grid item xs={12}>
          <FormSwitch
            label="Debug"
            name="options.debug"
          />
        </Grid>
        <Grid item xs={12}>
          <FormSwitch
            label="Show as popup"
            name="options.show_as_popup"
          />
        </Grid>
        <Grid item xs={12}>
          <FormSwitch
            label="Disable modal scroll"
            name="options.disable_modal_scroll"
          />
        </Grid>
        <Grid item xs={12}>
          <FormSwitch
            label="Disable modal focus"
            name="options.disable_modal_focus"
          />
        </Grid>
      </Grid>
      <Grid item sm={6} xs={12}>
        <FormInput
          label="Video menu DIV id"
          name="options.video_menu_div"
        />
      </Grid>
    </Permission>
  </Grid>
);

export default TabOptions;
